<template>
  <div id="community-finances">
    <div class="info-box">
      <div class="icon-wrapper">
        <i class="fas fa-cash-register"></i>
      </div>
      <div class="editable">
        <div class="single-info">
          <div class="label">Tekući račun</div>
          <div class="value">
            <span class="account">{{ accountDetails.account }}</span>
          </div>
        </div>
        <div class="single-info">
          <div class="label">PIB</div>
          <div class="value">
            <span>{{ accountDetails.pib }}</span>
          </div>
        </div>
        <div class="single-info">
          <div class="label">Matični broj</div>
          <div class="value">
            <span>{{ accountDetails.mb }}</span>
          </div>
        </div>
        <div class="single-info action">
          <div class="edit-btn">
            <a
              class="btn btn-primary edit-btn"
              @click="showModal('ModalContentEditCommunityAccount')"
              >Izmeni podatke</a
            >
          </div>
        </div>
      </div>
      <div class="balance">
        <div class="init-wrapper">
          <i
            class="fas fa-cogs icon--mod"
            @click="showSettingsModal = true"
          ></i>
          <i
            class="far fa-edit icon--mod"
            @click="showBalanceModal = true"
            v-if="balanceInitAvailable"
          >
            <span class="pulse"></span>
          </i>
        </div>
        <div class="partial-values">
          <p class="income">
            +
            {{
              accountDetails.positive_balance
                ? accountDetails.positive_balance
                : 0 | addSeparator
            }}
          </p>
          <p class="expense">
            {{
              accountDetails.negative_balance
                ? accountDetails.negative_balance
                : -0 | addSeparator
            }}
          </p>
        </div>
        <h2 class="value">
          {{
            accountDetails.balance ? accountDetails.balance : 0 | addSeparator
          }}
        </h2>
      </div>
    </div>
    <div class="boxes">
      <div class="box-wrapper" v-for="table in tables" :key="table.name">
        <finances-mini-table
          :title="table.title"
          :name="table.name"
          :columns="table.columns"
          :actions="table.actions"
          :modalWider="table.showWider"
        ></finances-mini-table>
      </div>
    </div>
    <table-community-finances></table-community-finances>
    <modal-confirm-action
      v-if="showBalanceModal"
      @close="showBalanceModal = false"
      @confirm="initializeBalance"
    >
      <div class="balance-info">
        Postavite početno stanje blagajne
        <div class="balance-alert">*</div>
      </div>
      <input
        type="text"
        class="form-control form-control-lg balance-amount"
        placeholder=" "
        v-model.lazy="initialBalance"
        v-money="{}"
      />
      <div class="balance-alert">
        *Navedena akcija može biti izvedena samo dok ne postoji ni jedna
        transakcija.
      </div>
      <div class="balance-alert">
        Postavljeni iznos može kasnije biti izmenjen kroz izmenu/brisanje prve
        transakcije.
      </div>
    </modal-confirm-action>
    <modal-confirm-action
      v-if="showSettingsModal"
      title="Podešavanje vidljivosti finansija"
      @close="showSettingsModal = false"
      @confirm="setSettings"
    >
      <h5>Stanari mogu da vide:</h5>
      <br />
      <checkbox
        label="Stanje računa zajednice"
        :checked="paymentVisibilitySettings.see_balance"
        @change="
          paymentVisibilitySettings.see_balance = !paymentVisibilitySettings.see_balance
        "
      ></checkbox>
      <br />
      <checkbox
        label="Prihode"
        :checked="paymentVisibilitySettings.see_income"
        @change="
          paymentVisibilitySettings.see_income = !paymentVisibilitySettings.see_income
        "
      ></checkbox>
      <br />
      <checkbox
        label="Rashode"
        :checked="paymentVisibilitySettings.see_expense"
        @change="
          paymentVisibilitySettings.see_expense = !paymentVisibilitySettings.see_expense
        "
      ></checkbox>
    </modal-confirm-action>
  </div>
</template>
<script>
import { mapMutations, mapActions, mapState } from 'vuex';
import FinancesMiniTable from '@/components/community/FinancesMiniTable';
import TableCommunityFinances from '@/components/table/TableCommunityFinances.vue';
import { financesInstance } from '@/axios/axios.js';
import { addSeparatorMixin } from '@/mixins/mixins.js';
import ModalConfirmAction from '@/components/modal/ModalConfirmAction';
import checkbox from '@/components/common/Checkbox.vue';
export default {
  name: 'CommunityFinancesHome',
  components: {
    financesMiniTable: FinancesMiniTable,
    tableCommunityFinances: TableCommunityFinances,
    modalConfirmAction: ModalConfirmAction,
    checkbox: checkbox
  },
  mixins: [addSeparatorMixin],
  data() {
    return {
      showBalanceModal: false,
      showSettingsModal: false,
      initialBalance: '',
      paymentVisibilitySettings: {
        see_expense: false,
        see_income: false,
        see_balance: false
      },
      tables: [
        {
          title: 'Transakcije',
          name: 'transactions',
          columns: [
            { key: 'div_description', label: 'Komitent', flex: 2 },
            { key: 'timestamp', label: 'Datum', flex: 3 },
            { key: 'amount', label: 'Iznos (RSD)', flex: 2 }
          ],
          actions: [
            {
              key: 3,
              label: 'Izvod',
              class: 'btn-primary',
              modalName: 'ModalContentTransactionIncome'
            },
            {
              key: 1,
              label: 'Nova uplata',
              class: 'btn-primary',
              modalName: 'ModalContentTransactionIncome'
            },
            {
              key: 2,
              label: 'Nova isplata',
              class: 'btn-danger',
              modalName: 'ModalContentTransactionPayout'
            }
          ]
        },
        {
          title: 'Obaveze',
          name: 'expenses',
          columns: [
            { key: 'name', label: 'Opis', flex: 2 },
            { key: 'price', label: 'Iznos (RSD)', flex: 1 }
          ],
          actions: [
            {
              key: 1,
              label: 'Nova obaveza',
              class: 'btn-primary',
              modalName: 'ModalContentExpense'
            }
          ]
        },
        {
          title: 'Računi',
          name: 'invoices',
          showWider: true,
          columns: [
            { key: 'description', label: 'Opis', flex: 2 },
            { key: 'total_amount', label: 'Iznos (RSD)', flex: 1 }
          ],
          actions: [
            {
              key: 1,
              label: 'Novi račun',
              class: 'btn-primary',
              modalName: 'ModalContentInvoice'
            }
          ]
        }
      ]
    };
  },
  computed: {
    ...mapState('finances', ['accountDetails']),
    balanceInitAvailable() {
      return (
        this.$store.state.finances.invoices.count +
          this.$store.state.finances.transactions.count ==
        0
      );
    }
  },
  created() {
    this.getAccountDetails();
    financesInstance
      .get(
        `communities/${
          this.$store.getters.getActiveCommunity.id
        }/paymentVisibility`
      )
      .then(({ data }) => {
        this.paymentVisibilitySettings = {
          see_expense:
            data.paymentVisibilitySettings.see_expense == 1 ? true : false,
          see_income:
            data.paymentVisibilitySettings.see_income == 1 ? true : false,
          see_balance:
            data.paymentVisibilitySettings.see_balance == 1 ? true : false
        };
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods: {
    ...mapMutations(['cardOpened']),
    ...mapMutations('table', ['setTableBadge', 'unsetTableData']),
    ...mapMutations('modal', ['showModal']),
    ...mapActions('finances', ['getAccountDetails', 'getTableData']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    setSettings() {
      financesInstance
        .post(
          `communities/${
            this.$store.getters.getActiveCommunity.id
          }/setPaymentVisibility`,
          {
            seeBalance:
              this.paymentVisibilitySettings.see_balance == true ? 1 : 0,
            seeIncome:
              this.paymentVisibilitySettings.see_income == true ? 1 : 0,
            seeExpense:
              this.paymentVisibilitySettings.see_expense == true ? 1 : 0
          }
        )
        .then(() => {
          this.showSuccessModal();
          this.showSettingsModal = false;
        })
        .catch(err => {
          console.log(err);
          this.showFailModal();
        });
    },
    initializeBalance() {
      const communityId = this.$store.getters.getActiveCommunity.id;
      const initialBalance = parseFloat(
        parseFloat(this.initialBalance.replace(/,/g, '')).toFixed(2)
      );

      financesInstance
        .post(`communities/${communityId}/setInitialBalance`, {
          initialBalance: initialBalance
        })
        .then(res => {
          console.log(res);
          this.showSuccessModal();
          this.getAccountDetails();
          this.getTableData({
            communityId: communityId,
            tableName: 'transactions'
          });
          this.showBalanceModal = false;
        })
        .catch(err => {
          console.log(err);
          this.showFailModal();
        });
    }
  },

  destroyed() {
    //unsetting badge when view is closed
    //this.unsetTableData();
    // this.setTableBadge('');
  }
};
</script>
<style scoped lang="scss">
.info-box {
  width: 100%;
  height: 100px;
  // border: 1px solid var(--primary-color);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);

  border-radius: 4px;
  display: flex;
  padding: 8px 8px 8px 0;

  .edit-btn {
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: white;
    padding: 6px;
  }

  .icon-wrapper {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      font-size: 4rem;
      color: var(--primary-color);
    }
  }
  .editable {
    flex: 7;
    border-left: 1px solid var(--primary-color);
    border-right: 1px solid var(--primary-color);
    border-color: black;
    display: flex;
    padding-left: 8px;
    .single-info {
      // width: 260px;
      flex: 1;
      .label {
        font-size: 1.3rem;
        font-weight: 600;
      }
      .value {
        margin-top: -6px;
        display: flex;
        justify-content: space-between;
        span {
          width: 190px;
          display: flex;
          align-items: center;
          white-space: nowrap;
        }
        .edit-btn {
          color: white;
          height: auto;
          font-size: 0.8rem;
          padding: 2px 6px;
        }
      }
      &.action {
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
    }
  }
  .balance {
    flex: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;

    .init-wrapper {
      position: absolute;
      left: 5px;
      top: 5px;
      font-size: 1.5rem;
      .icon--mod {
        position: relative;
        padding: 6px 6px 6px 8px;
        color: var(--primary-color);
      }

      .icon--mod:hover {
        cursor: pointer;
        color: var(--primary-color-lighten);
      }

      .pulse {
        display: block;
        position: absolute;
        pointer-events: none;
        width: 2.4rem;
        height: 2.4rem;
        border-radius: 50%;
        top: 0px;
        left: 0px;
        cursor: pointer;
        // box-shadow: 0 0 0 rgba(204, 44, 44, 0.4);
        animation: pulse 2s infinite;
      }
      .pulse:hover {
        // animation: none;
      }
    }
    .partial-values {
      text-align: right;
      .expense,
      .income {
        font-size: 1rem;
        margin: 0;
      }
      .expense {
        color: red;
      }
      .income {
        color: green;
      }
    }

    .value {
      text-align: right;
      padding: 0;
      margin: 0;
    }
  }
}
.boxes {
  display: flex;
  height: 250px;
  margin: 1rem 0;
  .box-wrapper {
    flex: 2;
    padding: 0 16px;
    &:first-child {
      padding: 0;
      flex: 3;
    }
    &:last-child {
      padding: 0;
    }
  }
}

.balance-info {
  display: flex;
}

.balance-amount {
  margin-bottom: 10px;
}

.balance-alert {
  color: red;
}

@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(0, 121, 107, 0.4);
  }
  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(0, 121, 107, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(0, 121, 107, 0);
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(0, 121, 107, 0.4);
    box-shadow: 0 0 0 0 rgba(0, 121, 107, 0.4);
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(0, 121, 107, 0);
    box-shadow: 0 0 0 10px rgba(0, 121, 107, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(0, 121, 107, 0);
    box-shadow: 0 0 0 0 rgba(0, 121, 107, 0);
  }
}
</style>
